import { createContext, useContext, useEffect, useState } from 'react';
import fetcher from '../helper/fetcher';

const QrAuthContext = createContext();

export const QrAuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [user, setUser] = useState(null)
  const [receiver, setReceiver] = useState(null)
  useEffect(() => {
    fetcher.get("/qr/auth/valid_user")
      .then((res) => {
        if (res?.data?.success) {
          const user = res.data.data
          setUser(user)
          setIsAuthenticated(true)
        }
      })
      .catch((err) => {
        setIsAuthenticated(false)
      })
  }, [])

  const logout = () => {
    localStorage.clear()
    window.location.href = '/contact-card/login'
  };

  return (
    <QrAuthContext.Provider value={{
      isAuthenticated, setIsAuthenticated,
      logout, user, setUser, setReceiver,
      receiver
    }}>
      {children}
    </QrAuthContext.Provider>
  );
};

export const useQrAuth = () => useContext(QrAuthContext);
